import * as constants from './constants';
import { VIEW_MODE } from './fixtures';

const initialState = {
  mode: VIEW_MODE.GRID,
  showContentOverlay: false,
  showAppOverlay: false,
  isScrollable: true,
};

// eslint-disable-next-line import/prefer-default-export
export const configReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.SET_VIEW_MODE:
    return { ...state, mode: action.payload };
  case constants.SHOW_CONTENT_OVERLAY:
    return { ...state, showContentOverlay: true };
  case constants.HIDE_CONTENT_OVERLAY:
    return { ...state, showContentOverlay: false };
  case constants.SHOW_APP_OVERLAY:
    return { ...state, showAppOverlay: true };
  case constants.HIDE_APP_OVERLAY:
    return { ...state, showAppOverlay: false };
  case constants.DISABLE_ENTITIES_SCROLL:
    return { ...state, isScrollable: false };
  case constants.ENABLE_ENTITIES_SCROLL:
    return { ...state, isScrollable: true };
  default:
    return state;
  }
};
